<template>
  <div class="dataTables_wrapper form-inline dt-bootstrap" id="example1_wrapper">
    <div class="row">
      <div class="col-sm-6 text-left">
        <!--<div class="form-group text-left">-->
          <!--<div class="btn btn-default btn-table-title">匯出表單</div>-->
        <!--</div>-->
        <div class="form-group" v-if="brandBrief.length > 2 && $route.name !== 'storeInfo'">
          <!-- <select class="form-control h-38" v-model="brandSelect">
            <option value="0" v-if="roleType !== 10">== 品牌 ==</option>
            <option v-for="brand in brandBrief" :value="brand.value">
              {{brand.label}}
            </option>
          </select> -->
          <multiselect
            v-model="brandSelect"
            :options="brandBrief"
            :searchable="true"
            :allow-empty="false"
            :close-on-select="true"
            placeholder="== 品牌 =="
            :show-labels="false"
            :multiple="false"
            label="label"
            track-by="value"
          >
          </multiselect>
        </div>
        <div class="form-group" v-if="brandSelect.value !== 0 && brandSelect.value !== '0' && storeBrief.length > 2 && $route.name !== 'storeInfo'">
          <!-- <select class="form-control h-38" v-model="storeSelect">
            <option value="0">== 門市 ==</option>
            <option v-for="store in storeBrief" :value="store.value">
              {{store.label}}
            </option>
          </select> -->
              <multiselect
                v-model="storeSelect"
                :options="storeBrief"
                :searchable="true"
                :allow-empty="false"
                :close-on-select="true"
                placeholder="== 門市 =="
                :show-labels="false"
                :multiple="false"
                label="label"
                track-by="value"
              >
            </multiselect>
        </div>
        <br>
        <div class="form-group text-left">
          <select class="form-control h-38" v-model="typeSelect">
            <option v-for="type in typeList" :value="type.value">
              {{type.label}}
            </option>
          </select>
        </div>
        <br>
      </div>
      <div class="col-sm-6 text-right">
        <div class="form-group">
          <select class="form-control h-38" v-model="searchSelect">
            <option value="1">訂單編號</option>
            <option value="2" v-if="roleType === 99">使用者ID</option>
          </select>
        </div>
        <div class="form-group search-bar">
          <div class="input-group">
            <input class="form-control" type="text" v-model="searchResult">
            <span class="input-group-addon c-pointer" @click="getOrderList(1)"><i class="fa fa-search"></i></span>
          </div>
        </div>

      </div>
    </div>
    <div class="row">
      <div class="col-sm-12 table-responsive p-x-0">
        <table aria-describedby="example1_info" role="grid" id="example1" class="table table-bordered table-striped dataTable">
          <thead>
          <tr role="row">
            <th colspan="1" rowspan="1" aria-controls="example1" tabindex="0" class="">#</th>
            <th colspan="1" rowspan="1" aria-controls="example1" tabindex="0" class="">訂單編號</th>
            <!--<th colspan="1" rowspan="1" aria-controls="example1" tabindex="0" class="">ID</th>-->
            <!--<th colspan="1" rowspan="1" aria-controls="example1" tabindex="0" class="">狀態</th>-->
            <!--<th colspan="1" rowspan="1" aria-controls="example1" tabindex="0" class="">類型</th>-->
            <th colspan="1" rowspan="1" aria-controls="example1" tabindex="0" class="" v-if="roleType === 99">品牌(ID)</th>
            <th colspan="1" rowspan="1" aria-controls="example1" tabindex="0" class="" v-if="roleType === 99 || roleType === 30">分店(ID)</th>
            <!-- :TODO 將改成手機帳號ID-->
            <th colspan="1" rowspan="1" aria-controls="example1" tabindex="0" class="">訂購者<span v-if="roleType === 99">(ID)</span></th>
            <th colspan="1" rowspan="1" aria-controls="example1" tabindex="0" class="">電話</th>
            <th colspan="1" rowspan="1" aria-controls="example1" tabindex="0" class="">取餐</th>
            <!--<th colspan="1" rowspan="1" aria-controls="example1" tabindex="0" class="">商品數</th>-->
            <th colspan="1" rowspan="1" aria-controls="example1" tabindex="0" class="">總額</th>
            <!--<th colspan="1" rowspan="1" aria-controls="example1" tabindex="0" class="">付款狀態</th>-->
            <!--<th colspan="1" rowspan="1" aria-controls="example1" tabindex="0" class="">下訂時間</th>-->
            <!--<th colspan="1" rowspan="1" aria-controls="example1" tabindex="0" class="">付款方式</th>-->
            <!--<th colspan="1" rowspan="1" aria-controls="example1" tabindex="0" class="">pos機編號(收銀機代號)</th>-->
            <!--<th colspan="1" rowspan="1" aria-controls="example1" tabindex="0" class="">pos機交易序號</th>-->
            <!--<th colspan="1" rowspan="1" aria-controls="example1" tabindex="0" class="">pos機取餐號</th>-->
            <!--<th colspan="1" rowspan="1" aria-controls="example1" tabindex="0" class="">更新時間</th>-->
            <!--<th colspan="1" rowspan="1" aria-controls="example1" tabindex="0" class="">建立時間</th>-->
            <th colspan="1" rowspan="1" aria-controls="example1" tabindex="0" class="">狀態</th>
            <th colspan="1" rowspan="1" aria-controls="example1" tabindex="0" class="">原因</th>
            <th></th>
          </tr>
          </thead>
          <tbody v-if="isLoading">
            <tr>
              <td colspan="12" class="text-center">資料讀取中......</td>
            </tr>
          </tbody>
          <tbody v-else-if="orderList.length === 0">
            <tr style="background-color: white">
              <td rowspan="1" colspan="12" style="text-align: center; padding-bottom: 80px; padding-top:80px;">
                <img src="/static/img/noMatchdata.svg" style="max-width: 148px;" class="center-block logo">
                <span style="margin-bottom: 80px; color: #696969;">沒有符合的資料</span>
              </td>
            </tr>
          </tbody>
          <tbody v-else-if="orderList.length > 0">
          <tr class="even" role="row" v-for="(order, index) in orderList">
            <td class="sorting_1">{{index + 1}}</td>
            <td><router-link :to="{path: '/orderInfo/' + order.order_id}" target="_blank">{{order.order_sn}}</router-link></td>
            <!--<td>{{order.order_id}}</td>-->
            <!--<td>{{orderState(order.status)}}</td>-->
            <!--<td>-->
              <!--<span v-if="order.order_type === 1" class="label label-primary">一般單</span>-->
              <!--<span v-if="order.order_type === 2" class="label label-warning">團購單</span>-->
            <!--</td>-->
            <td v-if="roleType === 99">{{order.brand_name}}({{order.brand_id}})</td>
            <td v-if="roleType === 99 || roleType === 30">{{order.store_name}}({{order.store_id}})</td>
            <td>
              <span v-if="roleType !== 99 || $route.name == 'memberOrderTable'">{{order.name}}<span v-if="roleType === 99">({{order.shopper_id}})</span></span>
              <router-link target="_blank" :to="{path: '/memberOrderTable/' + order.shopper_id}"  v-if="roleType === 99 && $route.name !== 'memberOrderTable'">{{order.name}}({{order.shopper_id}})</router-link>
            </td>
            <td>{{order.phone}}</td>
            <td>{{order.delivery_type | deliveryName}}</td>
            <!--<td>{{order.amount}}</td>-->
            <td>＄{{order.money}}</td>
            <!--<td>{{payStateName(order.payment_status)}}</td>-->
            <!--<td>{{order.order_time}}</td>-->
            <!--<td>{{payType(order.pay_place_type)}}</td>-->
            <!--<td><span v-if="order.pos_order_sn">{{order.pos_order_sn}}({{order.pos_cashier_no}})</span></td>-->
            <!--<td>{{order.pos_order_no}}</td>-->
            <!--<td>{{order.pos_take_no}}</td>-->
            <!--<td>{{order.update_time}}</td>-->
            <!--<td>{{order.create_time}}</td>-->
            <td><label class="label" :class="statusColor(order.score_status)">{{scoreStatusName(order.score_status)}}</label></td>
            <td>{{order.reason}}</td>
            <td>
              <button class="btn btn-default" @click="getCurrentId(order.score_id, order.score_status)" data-toggle="modal" data-target="#scoreModal"><i class="fa fa-pencil" aria-hidden="true"></i></button>
            </td>
          </tr>
          </tbody>
        </table>
      </div>
      <paginate :pageAmount="pageAmount" :total="total" :isActive="isActive"
                :groupAmount="groupAmount" :clickPage="clickPage" ref="orderPaginate"
      >
      </paginate>
    </div>
    <m-modal :option="scoreOption" @trigger="trigger" :selectOptions="selectOptions" @selectOnChange="selectOnChange" :selectDefault="order.scoreStatus"></m-modal>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import datetimePicker from 'vue-datepicker/vue-datepicker-es6.vue'
import moment from 'moment'
import $ from 'jquery'
export default{
  components: {
    'date-time-picker': datetimePicker
  },
  data () {
    return {
      roleType: '',
      total: 1,
      count: 20,
      orderList: [],
      searchResult: '',
      shopper: '',
      orderSn: '',
      tableIndex: 1,
      pageGroup: 1,
      groupAmount: 10,
      searchSelect: 1,
      brandSelect: {
        value: 0,
        label: '== 品牌 =='
      },
      storeSelect: {
        value: 0,
        label: '== 門市 =='
      },
      typeSelect: 999,
      statusSelect: 999,
      deTypeSelect: 999,
      scoreOption: {
        id: 'scoreModal',
        title: '修改評分狀態',
        body: '確認修改評分狀態？',
        btns: [
          {
            name: '取消'
          },
          {
            name: '確定',
            event: 'scoreStatus'
          }
        ]
      },
      brandBrief: [],
      storeBrief: [],
      brandDefault: 0,
      typeList: [
        {label: '== 評分狀態 ==', value: 999},
        {label: '無狀態', value: 0},
        {label: '尚未確認', value: 9},
        {label: '門市確認', value: 10},
        {label: '門市取消', value: 19},
        {label: '總部確認', value: 50},
        {label: '總部取消', value: 59}
      ],
      order: {
        newState: 0,
        scoreId: 0,
        scoreStatus: ''
      },
      selectOptions: {
        name: '評分狀態',
        options: []
      },
      isLoading: true
    }
  },
  methods: {
    clickGroup (type) {
      if (type === 'left' && this.pageGroup !== 1) {
        this.pageGroup = this.pageGroup - 1
        this.tableIndex = this.groupAmount * this.pageGroup
        this.clickPage(this.tableIndex)
      } else if (type === 'right' && this.pageGroup !== Math.ceil(this.pageAmount / this.groupAmount)) {
        this.pageGroup = this.pageGroup + 1
        this.tableIndex = this.groupAmount * (this.pageGroup - 1) + 1
        this.clickPage(this.tableIndex)
      }
    },
    clickEnd (type) {
      if (type === 'pre') {
        this.clickPage(1)
        this.pageGroup = 1
      } else if (type === 'forward') {
        if (this.pageAmount) this.clickPage(this.pageAmount)
        else this.clickPage(1)
        this.pageGroup = Math.ceil(this.pageAmount / this.groupAmount)
      }
    },
    trigger (event) {
      if (event === 'scoreStatus') {
        this.scoreStatus()
      }
    },
    payType (type) {
      if (type === 10) {
        return '線上支付'
      } else if (type === 50) {
        return '店家支付'
      }
    },
    payStateName (state) {
      if (state === 11) {
        return '尚未付款'
      } else if (state === 12) {
        return '付款處理中'
      } else if (state === 13) {
        return '已收款'
      } else if (state === 21) {
        return '退款處理中'
      } else if (state === 22) {
        return '已退款'
      }
    },
    orderState (state) {
      if (state === 0) {
        return '訂單尚未確認'
      } else if (state === 1) {
        return '訂單已送出，尚未付款'
      } else if (state === 2) {
        return '付款中'
      } else if (state === 3) {
        return '訂單已付款，尚未通知店家'
      } else if (state === 99) {
        return '客人取消'
      } else if (state === 100) {
        return '未接單'
      } else if (state === 110) {
        return '已接單'
      } else if (state === 120) {
        return '店家退訂'
      } else if (state === 121) {
        return '系統退訂'
      } else if (state === 122) {
        return '已取消'
      } else if (state === 130) {
        return '已完成'
      } else if (state === 140) {
        return '已作廢'
      }
    },
    scoreStatusName (type) {
      if (type === 0) {
        return '無狀態'
      } else if (type === 9) {
        return '尚未確認'
      } else if (type === 10) {
        return '門市確認'
      } else if (type === 19) {
        return '門市取消'
      } else if (type === 50) {
        return '總部確認'
      } else if (type === 59) {
        return '總部取消'
      }
    },
    statusColor (type) {
      if (type === 0) {
        return 'label-default'
      } else if (type === 9) {
        return 'label-default'
      } else if (type === 10) {
        return 'label-success'
      } else if (type === 19) {
        return 'label-danger'
      } else if (type === 50) {
        return 'label-success'
      } else if (type === 59) {
        return 'label-danger'
      }
    },
    getCurrentId (scoreId, scoreStatus) {
      this.order.scoreId = scoreId
      this.order.scoreStatus = scoreStatus.toString()
    },
    selectOnChange (value) {
      this.order.newState = value
    },
    isActive (index) {
      if (this.tableIndex === index) return true
      else return false
    },
    clickPage (index) {
      this.tableIndex = index
      this.getOrderList()
    },
    scoreStatus () {
      var self = this
      var url = '/score/' + this.order.scoreId + '/status'
      var data = {
        score_status: this.order.newState
      }
      this.getDataH('put', url, data, function (response) {
        if (response.data.status === 200) {
          self.$notify({
            title: response.data.message,
            text: response.data.description,
            duration: 3000,
            type: 'success',
            width: 400
          })
          self.getOrderList(1)
        }
      })
    },
    getOrderList (page) {
      this.isLoading = true
      if (page) {
        this.tableIndex = page
        if (page === 1) this.pageGroup = 1
      }
      var self = this
      var roleType = parseInt(this.getRoleType, 10)
      var url
      const data = {
        page: this.tableIndex,
        size: this.count
      }
      if (roleType === 99) {
        url = '/order/blackOrderList?page=' + data.page + '&size=' + data.size + '&list_sort=create_time DESC'
      } else if (roleType === 30) {
        url = '/order/brandBlackOrderList?page=' + data.page + '&size=' + data.size + '&list_sort=create_time DESC'
      }
      if (this.searchResult && parseInt(this.searchSelect, 10) === 1) url = url + '&order_sn=' + this.searchResult
      else if (this.searchResult && parseInt(this.searchSelect, 10) === 2) url = url + '&shopper_id=' + this.searchResult
      if (this.brandSelect.value !== '0' && this.brandSelect.value !== 0 && url) url = url + '&brand_id=' + this.brandSelect.value
      if (this.storeSelect.value !== '0' && this.storeSelect.value !== 0 && url) url = url + '&store_id=' + this.storeSelect.value
      if (this.typeSelect !== '999' && this.typeSelect !== 999 && url) url = url + '&score_status=' + this.typeSelect
      if (url) {
        this.getDataH('get', url, null, function (response) {
          if (response.data.status === 200) {
            self.orderList = response.data.order_list
            self.total = response.data.total
            if (self.orderList.length) $('.odd').css('display', 'none')
            self.isLoading = false
          }
        })
      }
    },
    getBrandBrief () {
      var self = this
      self.brandBrief = [{label: '== 品牌 ==', value: 0}]
      var url = '/brand/listBrief?is_delete=0&is_opening=1&list_sort=name ASC'
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          var bList = response.data.list
          for (let i = 0; i < bList.length; i++) {
            let obj = {label: bList[i].name, value: bList[i].brand_id}
            if (!bList[i].is_visible) obj.label = obj.label + ' (測)'
            self.brandBrief.push(obj)
            if (i === 0 && self.roleType === 10) self.brandSelect = obj
            else if (i === 0 && bList.length === 1) self.brandSelect = obj
          }
          if (self.roleType === 30 || self.roleType === 99) self.getOrderList()
        }
      })
    },
    getStoreBrief (brandId) {
      console.log('getStoreBrief | BlackListTableTemp')
      this.storeBrief = []
      var self = this
      self.storeBrief = [{label: '== 門市 ==', value: 0}]
      var url = '/brand/' + brandId + '/storeListBrief?status=2&list_sort=name ASC'
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          var sList = response.data.list
          for (let i = 0; i <= sList.length; i++) {
            if (sList.length > 0) {
              let obj = {label: sList[i].name, value: sList[i].store_id}
              self.storeBrief.push(obj)
            }
            if (i === 0) {
              // if (self.getRoleType === '10' || self.getRoleType === 10) self.storeSelect = obj.value
              self.getOrderList(1)
            }
          }
        }
      })
    },
    pageShow (index) {
      var num = index / this.groupAmount
      if (this.pageGroup - 1 < num && num <= this.pageGroup) return true
      else return false
    }
  },
  created () {
    this.getBrandBrief()
    this.roleType = parseInt(this.getRoleType, 10)
    if (this.roleType === 99) {
      this.order.newState = '0'
      this.selectOptions.options = [
        {text: '無狀態', value: 0},
        {text: '尚未確認', value: 9},
        {text: '門市確認', value: 10},
        {text: '門市取消', value: 19},
        {text: '總部確認', value: 50},
        {text: '總部取消', value: 59}
      ]
    } else {
      this.order.newState = '50'
      this.selectOptions.options = [
        {text: '總部確認', value: 50},
        {text: '總部取消', value: 59}
      ]
    }
  },
  watch: {
    'menuTime.end.time' () {
      var lastDay = moment(this.menuTime.end.time, 'YYYY-MM-DD').add(1, 'days').format('YYYY-MM-DD')
      if (this.menuTime.start.time > lastDay) this.menuTime.start.time = lastDay
      this.startLimit = [
        {
          type: 'fromto',
          to: lastDay
        }
      ]
    },
    'menuTime.start.time' () {
      var lastDay = moment(this.menuTime.start.time).add('31', 'days')
      if (lastDay < moment()) this.menuTime.end.time = lastDay.format('YYYY-MM-DD')
      else this.menuTime.end.time = moment().format('YYYY-MM-DD')
      this.endLimit = [
        {
          type: 'fromto',
          from: moment(this.menuTime.start.time).subtract(1, 'days'),
          to: moment(this.menuTime.end.time).add(1, 'days')
        }
      ]
    },
    'brandSelect.value' () {
      this.storeSelect = {value: 0, label: '== 門市 =='}
      if (this.$route.name === 'storeInfo') {
        this.storeSelect.value = this.$route.params.store_id
        this.getStoreBrief(this.brandSelect.value)
      } if (this.brandSelect.value !== 0 && this.brandSelect.value !== '0') {
        this.getStoreBrief(this.brandSelect.value)
      } else {
        this.getOrderList(1)
      }
    },
    'storeSelect.value' () {
      this.getOrderList(1)
    },
    typeSelect () {
      this.getOrderList(1)
    },
    statusSelect () {
      this.getOrderList(1)
    },
    deTypeSelect () {
      this.getOrderList(1)
    }
  },
  computed: {
    ...mapGetters(['getRoleType']),
    getDataH () {
      return this.$parent.getDataH
    },
    pageAmount () {
      return Math.ceil(this.total / this.count)
    }
  }
}
</script>
<style lang="sass">
.active.btn-all, .active.btn-basic, .active.btn-gb
  opacity: 0.4
.p-10
 padding: 10px !important
.time-box
  max-width: 236px
  #start-box, #end-box
    width: auto
  #start-box input
    border-radius: 3px 0px 0px 0px !important
  #end-box input
    border-radius: 0px 0px 0px 3px !important
@media screen and (max-width: 768px)
  .time-box
    max-width: calc( 100vw - 20px)
@media screen and (max-width: 768px)
 .time-box .cov-vue-date .cov-datepicker
    width: calc(100vw - 90px)
</style>



// WEBPACK FOOTER //
// BlackListTableTemp.vue?4814f447